import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import AuthenticationConstants from 'sharedreact/constants/AuthenticationConstants';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import { isMac } from 'sharedreact/utils/Client';

import ServerinfoActions from 'workspaces/launcher/actions/ServerinfoActions';
import ServerInfoConstants from 'workspaces/launcher/constants/ServerInfoConstants';


const Content: {
  isAEOnPremises: boolean,
  isAESaaS: boolean,
  isAEPS2: boolean,
  isFlexoTools: boolean
} = {
  isAEOnPremises: false,
  isAESaaS: false,
  isAEPS2: false,
  isFlexoTools: false
};

class State extends Immutable.Record(Content) {
}

class ServerInfoStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  canDownloadAgent (): boolean {
    return (this.getState().isAESaaS || this.getState().isAEPS2) && !isMac();
  }

  canManageAgents (): boolean {
    return this.getState().isAESaaS || this.getState().isAEPS2;
  }  

  canManageTokens (): boolean {
    return this.getState().isAESaaS || this.getState().isAEPS2;
  }

  canDownloadPitStopEditor (): boolean {
    return this.getState().isAESaaS || this.getState().isAEOnPremises;
  }

  canDownloadArtProEditor () : boolean {
    return this.getState().isAESaaS || this.getState().isAEOnPremises;
  }

  canDownloadConnectionTools (): boolean {
    return this.getState().isAESaaS || this.getState().isAEOnPremises;
  }

  canDownloadFlexoWorkflowEditors (): boolean {
    return this.getState().isFlexoTools && !isMac();
  }
  
  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case ServerInfoConstants.GET_SUCCESS: {
        return state
          .set('isAESaaS', action.isAESaaS)
          .set('isAEOnPremises', action.isAEOnPremises)
          .set('isAEPS2', action.isAEPS2)
          .set('isFlexoTools', action.isFlexoTools);
      }
      case AuthenticationConstants.LOGIN_SUCCESS: {
        ServerinfoActions.fetch();
        return state;
      }
      default: {
        return state;
      }
    }
  }
}

export default new ServerInfoStore();
